<template>
  <!-- Review Section 07 -->
  <div class="search" style="height: 100vh;">
    <section class>
      <div class="container search_head">
        <div class="content-section-02 home_course home_1" style="background-color:#F9F9F9;">
          <div
            class="container course_hero search_text search_text_b"
            v-for="(modules, index) in content"
            :key="index"
          >
            <h2>সার্চের ফলাফল ({{ ++index }})</h2>
          </div>
        </div>
        <div class="container course_hero" v-if="content.length > 0">
          <div
            v-for="(modules, d_index) in content"
            :key="d_index"
            :value="modules.id"
            class="course_list_menu_1 course_list_menu_home"
          >
            <img :src="modules.picture_url" alt />
            <div class="row_course">
              <h2>{{ modules.name }}</h2>
              <p>{{ modules.module_count }} {{ $root.module_count.r_modules }}</p>
              <div class="row_course_right search_row offset-xl-1 zoom">
                <a @click="gotoCourse()">{{ $root.h_body_b.r_button }}</a>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="content-section-02 home_course home_1" style="background-color:#F9F9F9;">
            <div class="container course_hero search_text not_found_search">
              <h2>সার্চের ফলাফল (0)</h2>
            </div>
          </div>
          <section class="content-section-03 home_1" style="background-color:#FFF;">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-6 col-md-5 col-sm-6 col-10">
                  <div class="content-img-box text-center" style="width=80%;">
                    <span>
                      <img src="/assets/exported/box.png" alt />
                    </span>
                    <h2>কোন তথ্য পাওয়া যায় নাই</h2>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      content: [],
      query: "",
    };
  },
  mounted() {
    this.loadContents();
    this.$root.page_hook = this;
  },
  methods: {
    loadContents() {
      // Get Data From Offline
      var search_key;
      if (!navigator.onLine) {
        if (window.localStorage.getItem("search-course" + search_key) != null) {
          console.log("Local Data: search-course" + search_key);
          var localData = JSON.parse(
            window.localStorage.getItem("search-course" + search_key)
          );
          this.content = localData;
          return;
        }
      }
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
        },
      };
      if (this.query.length == 0) {
        return;
      }
      axios
        .get(
          this.$root.API_BASE_URL + "search-course?search_key=" + this.query,
          config
        )
        .then((response) => {
          response.data.forEach((element) => {
            this.content.push(element);
          });
          // Save Locally
          localStorage.setItem(
            "search-course" + search_key,
            JSON.stringify(response.data.data)
          );
        });
    },
    gotoCourse() {
      this.$router.push("/course_description");
      this.$router.go(this.$router.currentRoute);
    },
    nl2br(input) {
      if (input == null) {
        return "";
      }
      if (input.indexOf("\n") > 0) {
        return input.split("\n").join("<br>");
      } else {
        return input;
      }
    },
    beforeMount() {},
    beforeDestroy() {
      this.$root.page_hook = null;
    },
  },
};
</script>
<style scoped>
.course_list_menu_1 {
  margin-bottom: 70px;
}
.not_found_search {
  margin-top: -40px;
}
.search_text_b h2 {
  margin-top: 35px;
}
.search {
  padding-top: 50px;
}
.content-img-box {
  margin-left: 0px;
}
.content-img-box img {
  width: 65%;
}
.content-img-box h2 {
  font-size: 32px;
  padding-top: 20px;
}
.content-img-box span {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 7px 0px #0000004d;
  opacity: 1;
  border-radius: 60%;
  /* padding: 20px 20px; */
  width: 236px;
  height: 236px;
  padding: 75px 0px;
}
@media all and (max-width: 990px) {
  .search_text {
    margin-top: 50px;
  }
  .search {
    padding-top: 10px;
  }
  .not_found_search {
    margin-top: 0;
  }
  .search_text_b h2 {
    margin-top: 65px;
  }
}
@media all and (max-width: 768px) {
  .content-img-box {
    margin-left: 0px;
  }
  .search {
    padding-top: 0;
  }
  .content-img-box img {
    width: 50%;
  }
  .content-img-box h2 {
    font-size: 20px;
    padding-top: 0px;
  }
  .content-img-box span {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 7px 0px #0000004d;
    opacity: 1;
    border-radius: 60%;
    /* padding: 20px 20px; */
    width: 150px;
    height: 150px;
    padding: 60px 0px;
  }
}
</style>
